import * as z from "zod/v4";
import { selfServeOnboardingRowSchema } from "./get-self-serve-onboardings";

const timePeriodSchema = z.enum([
  "day",
  "week",
  "month",
  "last-month",
  "quarter",
  "all",
  "custom",
]);

const customRangeSchema = z.object({
  start: z.string().min(1),
  end: z.string().min(1),
});

// Extended row schema to include weighted revenue
export const myOnboardingRowSchema = selfServeOnboardingRowSchema.extend({
  weightedRevenue: z.number().nullable(),
});

export const getMyOnboardings = {
  name: "getMyOnboardings" as const,
  input: z
    .object({
      limit: z.number().min(1).max(100).default(30),
      offset: z.number().min(0).default(0),
      timePeriod: timePeriodSchema,
      customRange: customRangeSchema.optional(),
      product: z.enum(["returns", "order-editing"]).optional(),
      searchQuery: z.string().optional(),
      // Optional: filter by a specific user's email (for viewing other SE's data)
      userEmail: z.string().email().optional(),
    })
    .superRefine((value, ctx) => {
      if (value.timePeriod === "custom" && !value.customRange) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "customRange is required when timePeriod is custom",
          path: ["customRange"],
        });
      }
    }),
  output: z.object({
    onboardings: z.array(myOnboardingRowSchema),
    total: z.number(),
    limit: z.number(),
    offset: z.number(),
  }),
};

export type MyOnboardingRow = z.infer<typeof myOnboardingRowSchema>;
export type GetMyOnboardingsInput = z.infer<typeof getMyOnboardings.input>;
export type GetMyOnboardingsOutput = z.infer<typeof getMyOnboardings.output>;
